import React, { useCallback, useState } from 'react';
import { Switch, Route } from 'react-router-dom';
import { notification } from 'antd';
import TweenOne from 'rc-tween-one';
import SignIn from './SignIn';
import Register from './Register/Register';
import RegistrationConfirm from './RegistrationConfirm';
import RestorePassword from './RestorePassword';
import RestorePasswordConfirm from './RestorePasswordConfirm';
import EmailConfirm from '../SettingsData/Settings/EmailConfirm';
import {
 PhoneIcon,
 ArrowLeftIcon,
 ArrowRightIcon,
 NotificationIcon,
} from '../_assests';
import {
 Spin,
 Wrapper,
 Content,
 Header,
 Logo,
 Title,
 Phone,
 Auth,
 Tabs,
 Water,
 Manual,
 Footer,
 LogoBlock,
 PhoneBlock,
 Notification,
 DrawerBlock,
 DrawerButton,
} from './Home.styled';
import ChatwootWidget from '../_common/ChatwootWidget';
import { RootState } from '../../store/store';
import { shallowEqual, useSelector } from 'react-redux';
import DialogRegister from '../dialogs/DialogRegister';

interface Props {
 isLoading?: boolean;
}

export default function Home({ isLoading = false }: Props) {
 const configData = useSelector(
  (state: RootState) => state.config,
  shallowEqual,
 );

 const openDialogRegisterData = useSelector(
  (state: RootState) => state.openDialogRegister,
  shallowEqual,
 );

 const [activeNavItem, setActiveNavItem] = useState('signin');
 const [visible, setVisible] = useState(false);

 const showDrawer = () => {
  setVisible(true);
 };

 const onClose = () => {
  setVisible(false);
 };

 const navigation = [
  {
   key: 'signin',
   name: 'Вход',
   render: <SignIn onForgot={() => setActiveNavItem('restore')} />,
  },
  //{ key: 'register', name: 'Регистрация', render: <Registration /> },
  { key: 'restore', render: <RestorePassword /> },

  /**
   * Регистрация еще не доработана
   */
  // {
  //  key: 'register',
  //  name: 'Регистрация',
  //  render: <Register />,
  // },
 ];

 const slides = [
  {
   title: 'Без личного визита',
   description:
    'Получайте всю актуальную информацию в любое время без очередей',
  },
  {
   title: 'Удобно',
   description: 'Контролируйте состояние всех договоров в одном кабинете',
  },
  {
   title: 'Консультируйтесь онлайн',
   description:
    'Обращайтесь к специалистам и получайте ответы через форму обратной связи',
  },
 ];

 const { activeSlide, onSlideNext, onSlidePrev } = useSlider(slides.length);

 if (isLoading) return <Spin size="large" />;

 interface SlideProps {
  $url?: string;
  $height?: string;
 }

 return (
  <Wrapper
   $url={`/slide_${configData.sliderPrefix}}1.png`}
   style={{
    backgroundImage: `url(/slide_${configData.sliderPrefix}${activeSlide + 1}.png)`,
   }}
  >
   <Switch>
    <Route path="/register/:approveKey" component={RegistrationConfirm} />
    <Route
     path="/restore-password/:approveKey"
     component={RestorePasswordConfirm}
    />
    <Route
     path="/change-email/:approveKey"
     render={() => (
      <EmailConfirm
       showSpin={false}
       onSuccess={(message) => {
        notification.success({
         message,
         placement: 'bottomRight',
         duration: 7,
        });
       }}
      />
     )}
    />
   </Switch>

   <Header>
    <LogoBlock>
     <a href={configData.siteUrl}>
      <Logo
       style={{ height: `${configData.logoMainHeight}px` }}
       src={configData.logoFileName}
       alt={configData.companyShortName}
      />
     </a>

     <Title>
      <h1>Личный кабинет</h1>
      <p>для бизнеса</p>
     </Title>
    </LogoBlock>

    <PhoneBlock>
     <Phone>
      <PhoneIcon />
      {configData.companyPhone}
     </Phone>
     <Notification onClick={showDrawer}>
      <TweenOne
       animation={{
        scale: 0.8,
        yoyo: true,
        repeat: -1,
        duration: 800,
       }}
      >
       <NotificationIcon />
      </TweenOne>
     </Notification>
    </PhoneBlock>
   </Header>

   <Content>
    <Auth>
     <Tabs
      centered
      animated={false}
      destroyInactiveTabPane
      tabBarGutter={70}
      activeKey={activeNavItem}
      onChange={setActiveNavItem}
     >
      {navigation.map((navItem) => (
       <Tabs.TabPane
        key={navItem.key}
        tab={navItem.name}
        disabled={!navItem.name}
       >
        {navItem.render}
       </Tabs.TabPane>
      ))}
     </Tabs>
    </Auth>

    <Water>
     <article>
      <i>{activeSlide + 1}</i>
      <h2>{slides[activeSlide].title}</h2>
      <p>{slides[activeSlide].description}</p>
     </article>

     <span>
      <ArrowLeftIcon onClick={onSlidePrev} />
      <ArrowRightIcon onClick={onSlideNext} />
     </span>

     <Manual
      fileName="Инструкция пользователя ЛК ЮЛ.pdf"
      url={`${window.location.origin}/userManuals/${configData.userManual}`}
      loading={false}
     >
      Инструкция пользователя
     </Manual>
    </Water>
   </Content>

   <Footer />
   <DrawerBlock
    title="Уважаемые клиенты!"
    placement="right"
    closable={false}
    onClose={onClose}
    visible={visible}
    width={500}
    footer={<DrawerButton onClick={onClose}>Закрыть</DrawerButton>}
   >
    <div>
     <p>
      Предлагаем вам воспользоваться новым дистанционным сервисом – Личным
      кабинетом для юридических лиц, индивидуальных предпринимателей и
      физических лиц – владельцев нежилых помещений.
     </p>
     <ol>
      Личный кабинет позволяет:
      <li>
       {' '}
       • контролировать договоры, заключенные между вами и поставщиками услуг и
       ресурсов, для которых наша компания выполняет агентские функции;
      </li>
      <li>
       • дистанционно подать официальное обращение с официальным присвоением
       входящего номера и выбрать удобный способ получения ответа.
      </li>
     </ol>
     <ol>
      Функционал сервиса будет учитывать пожелания клиентов и существенно
      расширяться. В настоящее время в разработке находятся:
      <li> • возможность передачи показаний приборов учета; </li>
      <li>
       • детализация начислений за оказанные услуги по договорам с
       поставщиками;{' '}
      </li>
      <li> • прямая связь со специалистами, ответственными за договоры;</li>
      <li>
       {' '}
       • отслеживание статусов обращений от момента регистрации до получения
       ответа и сроки их обработки;
      </li>
      <li> • просмотр истории обращений клиента. </li>
     </ol>
     <p>
      Доступ автоматически получают все клиенты, которые в договорах с
      поставщиками ресурсов указали мобильный телефон.
     </p>
     <p>
      Если данных в вашем договоре нет, то вам необходимо обратиться к нам лично
      или через Почту России с официальным письмом от уполномоченного лица о
      предоставлении телефона и подключении услуги «Личный кабинет».
     </p>
     <b>
      Цените свое время и здоровье, используйте наши дистанционные сервисы!
     </b>
    </div>
   </DrawerBlock>
   {configData.showChatWoot === '1' ? <ChatwootWidget /> : ''}

   <DialogRegister open={true} />
  </Wrapper>
 );
}

function useSlider(count: number) {
 const [activeSlide, setActiveSlide] = useState(0);

 const onSlideNext = useCallback(() => {
  if (activeSlide < count - 1) {
   setActiveSlide(activeSlide + 1);
  } else {
   setActiveSlide(0);
  }
 }, [count, activeSlide]);

 const onSlidePrev = useCallback(() => {
  if (activeSlide === 0) {
   setActiveSlide(count - 1);
  } else {
   setActiveSlide(activeSlide - 1);
  }
 }, [count, activeSlide]);

 return { activeSlide, onSlideNext, onSlidePrev };
}
